module.exports = __webpack_public_path__ + "static/media/DropArrow.b68cdba8.svg";